module.exports = __webpack_public_path__ + "img/germany-stomach-cancer-female.5967d97f.png";